import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { iconSize, iconColor, getButtonType } from '../ButtonBase';
import { ButtonStyled, ButtonContent, NoWrap } from './ButtonStyledComponents';
import * as Icons from '../../Icons';
import * as AliasedIcons from '../../Icons/aliases';
export default function Button(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      type = _ref.type,
      submit = _ref.submit,
      reset = _ref.reset,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      fullwidth = _ref.fullwidth,
      fullheight = _ref.fullheight,
      size = _ref.size,
      color = _ref.color,
      labelText = _ref.labelText,
      props = _objectWithoutProperties(_ref, ["children", "icon", "type", "submit", "reset", "isLoading", "loadingText", "fullwidth", "fullheight", "size", "color", "labelText"]);

  var withIcon = icon && !children;
  var Icon = Icons[icon] || AliasedIcons[icon];
  var markup = React.createElement(NoWrap, null, icon && React.createElement(Icon, {
    color: iconColor(type, color),
    size: iconSize(size)
  }), children && React.createElement(ButtonContent, null, children));
  var loadingMarkup = React.createElement(NoWrap, null, loadingText);
  var ariaProps = {};

  if (labelText) {
    ariaProps = {
      'aria-label': labelText
    };
  }

  return React.createElement(ButtonStyled, _extends({
    typeStyle: type,
    size: size,
    fullwidth: fullwidth,
    fullheight: fullheight,
    color: color,
    type: getButtonType({
      submit: submit,
      reset: reset
    }),
    withIcon: withIcon
  }, ariaProps, props), isLoading ? loadingMarkup : markup);
}
Button.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'secondary', 'destroy']),
  fullwidth: PropTypes.bool,
  fullheight: PropTypes.bool,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  loadingText: PropTypes.string,
  reset: PropTypes.bool,
  submit: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary', 'text', 'white', 'destroy', 'dark']),
  labelText: PropTypes.string
};
Button.defaultProps = {
  children: null,
  color: 'primary',
  fullwidth: false,
  fullheight: false,
  icon: null,
  isLoading: false,
  size: null,
  loadingText: '',
  reset: false,
  submit: false,
  type: 'primary',
  labelText: null
};